  (function() {
    var modal = document.getElementById('tv-viz-modal-inline');
    if (!modal || modal.dataset.tvVizBound === 'true') return;
    modal.dataset.tvVizBound = 'true';

    var trigger = document.querySelector('[data-tv-viz-open][aria-controls="tv-viz-modal-inline"]');
    var panel = modal.querySelector('.tv-viz-modal__panel');
    var container = modal.querySelector('.tv-viz-modal__container');
    var closeControls = modal.querySelectorAll('[data-tv-viz-close]');
    var distanceInput = modal.querySelector('[data-tv-viz-distance]');
    var wallInput = modal.querySelector('[data-tv-viz-wall]');
    var recsContainer = modal.querySelector('[data-tv-viz-recommendations]');

    var currentInches = parseInt(panel.getAttribute('data-current-size'), 10) || 55;

    var mountMode = 'stand';
    var initialised = false;
    var activeSize = null;
    var roomDistance = null;
    var wallSpace = null;
    var scrollY = 0;
    var lastFocusedElement = null;
    var focusableSelectors = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    /* ── TV size data ── */
    var sizeNumbers = [32, 43, 50, 55, 65, 75, 85, 98];
    if (sizeNumbers.indexOf(currentInches) === -1) {
      sizeNumbers.push(currentInches);
      sizeNumbers.sort(function(a, b) { return a - b; });
    }

    var tvSizes = sizeNumbers.map(function(inches) {
      var diag = inches * 2.54;
      return {
        inches: inches,
        widthCm: Math.round(diag * (16 / Math.sqrt(337))),
        heightCm: Math.round(diag * (9 / Math.sqrt(337))),
        label: inches + '″'
      };
    });

    /* ── Helpers ── */
    function r1(v) { return Math.round(v * 10) / 10; }
    function fmt(v) { return r1(v).toFixed(1) + ' m'; }

    function getDistanceRange(s) {
      var mn = Math.max(1, s.inches * 0.0305);
      var mx = Math.max(mn + 0.7, s.inches * 0.0615);
      return { min: r1(mn), max: r1(mx), ideal: r1((mn + mx) / 2) };
    }

    function getNearestSize(inches, dir) {
      var idx = sizeNumbers.indexOf(inches);
      return idx < 0 ? null : (tvSizes[idx + dir] || null);
    }

    function getFitScore(s, dist, wall) {
      var rng = getDistanceRange(s);
      var span = Math.max(0.8, rng.max - rng.min);
      var dOff = Math.abs(dist - rng.ideal);
      var dScore = 100 - Math.min(42, (dOff / span) * 48);
      var wScore = 100;
      if (wall < s.widthCm + 12) wScore = Math.max(48, 70 - ((s.widthCm + 12 - wall) * 0.7));
      else if (wall < s.widthCm + 30) wScore = 84;
      var sc = Math.max(45, Math.min(98, Math.round(dScore * 0.68 + wScore * 0.32)));
      var verdict = 'Measure carefully', status = 'Check fit';
      if (sc >= 90) { verdict = 'Perfect match'; status = 'Recommended'; }
      else if (sc >= 80) { verdict = 'Great fit'; status = 'Recommended'; }
      else if (sc >= 68) { verdict = 'Good with checks'; status = 'Worth considering'; }
      return { score: sc, status: status, verdict: verdict,
        summary: 'Ideal viewing range for this size is ' + fmt(rng.min) + ' – ' + fmt(rng.max) + '.',
        points: [
          dist >= rng.min && dist <= rng.max ? 'Works well at your ' + fmt(dist) + ' viewing distance' : 'Your viewing distance sits outside the ideal range',
          dist <= rng.ideal + 0.4 && dist >= rng.ideal - 0.4 ? 'Comfortable 4K immersion for this size' : 'Picture feel depends on how cinematic you want it to be',
          wall >= s.widthCm + 30 ? 'Fits comfortably within your wall width' : (wall >= s.widthCm + 12 ? 'Fits, but leave room for furniture and brackets' : 'Wall width is tight for this screen')
        ] };
    }

    function getFitContextCopy(s, dist, wall) {
      var placement = mountMode === 'wall' ? 'wall-mounted' : 'on a stand';
      return 'For the selected ' + s.label + ' TV ' + placement + ', using ' + fmt(dist) + ' viewing distance and ' + wall + ' cm of wall width.';
    }

    function getFitVerdictCopy(s, score) {
      if (score.score >= 90) return s.label + ' is a perfect match';
      if (score.score >= 80) return s.label + ' is a great fit';
      if (score.score >= 68) return s.label + ' can work with a quick double-check';
      return s.label + ' needs careful measuring';
    }

    function getWallFitCopy(s, w) {
      var clearance = w - s.widthCm;
      if (clearance >= 30) return 'Wall clearance: about ' + clearance + ' cm more than the screen width.';
      if (clearance >= 12) return 'Wall clearance: about ' + clearance + ' cm, so check sockets, furniture and bracket depth.';
      return 'Wall clearance: only about ' + Math.max(0, clearance) + ' cm spare. Measure carefully before buying.';
    }

    /* ── Positioning against the real room photo ── */
    var ROOM_CM = 335;
    var STAND_BOTTOM = 29.6;
    var WALL_CENTER = 43;
    var ROOM_ASPECT = 1.5;
    var STAND_IMAGE_RATIO = 650 / 1040;
    var WALL_IMAGE_RATIO = 620 / 1040;

    var els = {};

    function cacheEls() {
      els.room      = panel.querySelector('[data-tv-viz-room]');
      els.standTv   = panel.querySelector('[data-tv-viz-stand-tv]');
      els.wallTv    = panel.querySelector('[data-tv-viz-wall-tv]');
      els.sizeLabel = panel.querySelector('[data-tv-viz-label]');
      els.dimW      = panel.querySelector('[data-tv-viz-dim-w]');
    }

    function positionTv(size) {
      if (!els.room) return;
      var tvWidthPct = Math.max(19, Math.min(67, (size.widthCm / ROOM_CM) * 100));
      var ratio = mountMode === 'wall' ? WALL_IMAGE_RATIO : STAND_IMAGE_RATIO;
      var tvHeightPct = tvWidthPct * ROOM_ASPECT * ratio;
      var tvTopPct = mountMode === 'wall'
        ? WALL_CENTER - (tvHeightPct / 2)
        : (100 - STAND_BOTTOM) - tvHeightPct;
      var measureTop = mountMode === 'wall'
        ? WALL_CENTER + (tvHeightPct / 2) + 2.8
        : (100 - STAND_BOTTOM) - 2.8;

      var isCurrent = (size.inches === currentInches);
      els.sizeLabel.querySelector('[data-info="size-label"]').textContent = size.label + (isCurrent ? ' — this TV' : '');
      els.dimW.querySelector('[data-info="dim-w"]').textContent = size.widthCm + ' cm';
      els.room.setAttribute('data-mount', mountMode);
      els.room.style.setProperty('--tv-width', tvWidthPct + '%');
      els.room.style.setProperty('--tv-label-top', Math.max(4.5, tvTopPct - 6.2) + '%');
      els.room.style.setProperty('--measure-top', Math.min(86, measureTop) + '%');
      els.room.style.setProperty('--measure-width', tvWidthPct + '%');
    }

    /* ── Update text displays ── */
    function updateText(size) {
      var rng = getDistanceRange(size);
      panel.querySelector('[data-info="width"]').textContent = size.widthCm + ' cm';
      panel.querySelector('[data-info="height"]').textContent = size.heightCm + ' cm';
      panel.querySelector('[data-info="distance"]').textContent = fmt(rng.min) + ' – ' + fmt(rng.max);
      panel.querySelector('[data-info="room-distance"]').textContent = fmt(roomDistance);
      panel.querySelector('[data-info="room-distance-pill"]').textContent = fmt(roomDistance);
      panel.querySelector('[data-info="wall-space"]').textContent = wallSpace + ' cm';
      panel.querySelector('[data-info="mount-label"]').textContent = mountMode === 'wall' ? 'Wall mounted' : 'On stand';

      var score = getFitScore(size, roomDistance, wallSpace);
      panel.querySelector('[data-info="fit-score"]').textContent = score.score + '%';
      panel.querySelector('.tv-viz__score-ring').style.setProperty('--score', score.score + '%');
      panel.querySelector('[data-info="fit-status"]').textContent = score.status;
      panel.querySelector('[data-info="fit-verdict"]').textContent = getFitVerdictCopy(size, score);
      panel.querySelector('[data-info="fit-context"]').textContent = getFitContextCopy(size, roomDistance, wallSpace);
      panel.querySelector('[data-info="fit"]').textContent = score.summary;
      var pts = panel.querySelector('[data-info="fit-points"]');
      pts.innerHTML = '';
      score.points.forEach(function(p) {
        var li = document.createElement('li');
        li.textContent = p;
        pts.appendChild(li);
      });
      panel.querySelector('[data-info="wall-fit"]').textContent = getWallFitCopy(size, wallSpace);
    }

    function updateSizeButtons(size) {
      panel.querySelectorAll('.tv-viz__size-btn').forEach(function(btn) {
        var sel = btn.getAttribute('data-inches') == size.inches;
        btn.setAttribute('aria-checked', sel ? 'true' : 'false');
        btn.setAttribute('tabindex', sel ? '0' : '-1');
      });
    }

    /* ── Recommendations ── */
    function buildRecommendations() {
      if (!recsContainer || recsContainer.children.length) return;
      for (var i = 0; i < 3; i++) {
        var card = document.createElement('a');
        card.className = 'tv-viz__rec-card';
        card.setAttribute('data-recommendation-role', '');
        card.innerHTML = '<span class="tv-viz__rec-role"></span><strong class="tv-viz__rec-title"></strong><span class="tv-viz__rec-copy"></span><span class="tv-viz__rec-cta">View similar TVs →</span>';
        recsContainer.appendChild(card);
      }
    }

    function updateRecommendations(size) {
      if (!recsContainer) return;
      var sm = getNearestSize(size.inches, -1);
      var bg = getNearestSize(size.inches, 1);
      var idx = sizeNumbers.indexOf(size.inches);
      var data = [{ role: 'Best fit', size: size, copy: 'Closest to your current size choice, viewing distance and wall width.' }];
      if (bg) data.push({ role: 'Bigger screen', size: bg, copy: 'A larger option if you want more impact and still have the wall width.' });
      if (sm) data.push({ role: 'Smaller size', size: sm, copy: 'An easier fit if you prefer a calmer screen size for the same space.' });
      if (data.length < 3) {
        var fallback = bg ? tvSizes[idx + 2] : tvSizes[idx - 2];
        if (fallback) {
          data.push({
            role: bg ? 'Larger step' : 'Smaller step',
            size: fallback,
            copy: bg ? 'A bigger jump for rooms that can handle a more cinematic screen.' : 'A more compact alternative if you want extra breathing room.'
          });
        }
      }
      var cards = recsContainer.querySelectorAll('.tv-viz__rec-card');
      for (var i = 0; i < cards.length; i++) {
        if (!data[i]) { cards[i].hidden = true; continue; }
        cards[i].hidden = false;
        cards[i].setAttribute('data-recommendation-role', data[i].role.toLowerCase().replace(/\s+/g, '-'));
        cards[i].href = '/search?q=' + encodeURIComponent(data[i].size.inches + '" TV');
        cards[i].querySelector('.tv-viz__rec-role').textContent = data[i].role;
        cards[i].querySelector('.tv-viz__rec-title').textContent = data[i].size.label + ' TVs';
        cards[i].querySelector('.tv-viz__rec-copy').textContent = data[i].copy + ' Width about ' + data[i].size.widthCm + ' cm.';
      }
    }

    /* ── Main set size ── */
    function setTvSize(size, options) {
      activeSize = size;
      options = options || {};
      var rng = getDistanceRange(size);
      if (roomDistance === null || options.resetDistance) {
        roomDistance = rng.ideal;
        distanceInput.value = String(roomDistance);
      }
      if (wallSpace === null || options.resetWall) {
        wallSpace = Math.min(280, Math.max(140, size.widthCm + 35));
        wallInput.value = String(wallSpace);
      }
      positionTv(size);
      updateText(size);
      updateSizeButtons(size);
      updateRecommendations(size);
    }

    /* ── Build UI ── */
    function buildSizeButtons() {
      var c = panel.querySelector('.tv-viz__sizes');
      if (!c || c.children.length) return;
      tvSizes.forEach(function(size) {
        var btn = document.createElement('button');
        btn.className = 'tv-viz__size-btn';
        btn.setAttribute('role', 'radio');
        btn.setAttribute('aria-checked', 'false');
        btn.setAttribute('tabindex', '-1');
        btn.setAttribute('data-inches', String(size.inches));
        btn.type = 'button';
        btn.textContent = size.label;
        if (size.inches === currentInches) btn.setAttribute('data-current', 'true');
        btn.addEventListener('click', function() { setTvSize(size, { resetDistance: true, resetWall: true }); });
        btn.addEventListener('keydown', handleSizeKeydown);
        c.appendChild(btn);
      });
    }

    function handleSizeKeydown(e) {
      var keys = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'];
      if (keys.indexOf(e.key) === -1) return;
      e.preventDefault();
      var btns = Array.prototype.slice.call(panel.querySelectorAll('.tv-viz__size-btn'));
      var idx = btns.indexOf(e.currentTarget), next = idx;
      if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = Math.max(0, idx - 1);
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = Math.min(btns.length - 1, idx + 1);
      if (e.key === 'Home') next = 0;
      if (e.key === 'End') next = btns.length - 1;
      var s = tvSizes.find(function(c) { return String(c.inches) === btns[next].getAttribute('data-inches'); });
      if (s) { setTvSize(s, { resetDistance: true, resetWall: true }); btns[next].focus(); }
    }

    function bindControls() {
      panel.querySelectorAll('.tv-viz__mount-btn').forEach(function(btn) {
        btn.addEventListener('click', function() {
          mountMode = btn.getAttribute('data-mount');
          panel.querySelectorAll('.tv-viz__mount-btn').forEach(function(b) {
            b.classList.remove('tv-viz__mount-btn--active');
            b.setAttribute('aria-pressed', 'false');
          });
          btn.classList.add('tv-viz__mount-btn--active');
          btn.setAttribute('aria-pressed', 'true');
          if (activeSize) setTvSize(activeSize);
        });
      });
      distanceInput.addEventListener('input', function() {
        roomDistance = parseFloat(distanceInput.value);
        if (activeSize) { updateText(activeSize); }
      });
      wallInput.addEventListener('input', function() {
        wallSpace = parseInt(wallInput.value, 10);
        if (activeSize) { updateText(activeSize); }
      });
    }

    function init() {
      if (initialised) return;
      initialised = true;
      cacheEls();
      buildSizeButtons();
      buildRecommendations();
      bindControls();
      var initial = tvSizes.find(function(s) { return s.inches === currentInches; }) || tvSizes[3];
      setTvSize(initial, { resetDistance: true, resetWall: true });
    }

    /* ── Modal open/close ── */
    function openModal() {
      init();
      lastFocusedElement = document.activeElement;
      scrollY = window.scrollY || window.pageYOffset || 0;
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('tv-viz-modal-open');
      document.body.style.top = '-' + scrollY + 'px';
      window.setTimeout(function() {
        var sel = panel.querySelector('.tv-viz__size-btn[aria-checked="true"]');
        (sel || container).focus();
        /* Reposition after layout paint */
        if (activeSize) positionTv(activeSize);
      }, 60);
    }

    function closeModal() {
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('tv-viz-modal-open');
      document.body.style.top = '';
      window.scrollTo(0, scrollY || 0);
      if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') lastFocusedElement.focus();
    }

    function trapFocus(e) {
      if (modal.getAttribute('aria-hidden') === 'true' || e.key !== 'Tab') return;
      var focusable = Array.prototype.slice.call(modal.querySelectorAll(focusableSelectors)).filter(function(el) {
        return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
      });
      if (!focusable.length) return;
      var first = focusable[0], last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    /* ── Bind events ── */
    if (trigger) trigger.addEventListener('click', openModal);
    closeControls.forEach(function(c) { c.addEventListener('click', closeModal); });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') closeModal();
      trapFocus(e);
    });

    /* Reposition on window resize */
    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() { if (activeSize && modal.getAttribute('aria-hidden') === 'false') positionTv(activeSize); }, 150);
    });

    window.__tvVizInit = init;
  })();